export class GeneralContactForm {
    identite: string;
    message: string;
    telephone: string;
    mail: string;

    constructor(options?: any) {
        if (options) {
            this.identite = options.identite;
            this.message = options.message;
            this.telephone = options.telephone;
            this.mail = options.mail;
        }
    }
}

export class EtablissementContactForm {
    servicesDemandes: ServiceDemande[] = new Array<ServiceDemande>();
    codePostal: number;
    ville: string;
    etablissement: string;
    nomContact: string;
    fonction: string;
    telephone: string;
    mail: string;

    constructor(options?: any) {
        if (options) {
            this.servicesDemandes = options.servicesDemandes;
            this.codePostal = options.codePostal;
            this.ville = options.ville;
            this.etablissement = options.etablissement;
            this.nomContact = options.nomContact;
            this.fonction = options.fonction;
            this.telephone = options.telephone;
            this.mail = options.mail;
        }
    }
}
export class CoordonneesEtudiantForm {
    id_instance: number;
    telephone: string;
    email: string;

    constructor(options?: any) {
        if (options) {
            this.id_instance = options.id_instance;
            this.telephone = options.telephone;
            this.email = options.email;
        }
    }
}

export class ServiceDemande {
    id_produit = 0;
    titre_produit = '';
    id_instance = '';
    nom_instance = '';

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.titre_produit = options.titre_produit;
            this.id_instance = options.id_instance;
            this.nom_instance = options.nom_instance;
        }
    }
}
